import { Check } from "lucide-react";
import { DietType } from "@/i18n/locales/diets";

interface DietTypeCardProps {
    diet: DietType;
    isSelected: boolean;
    onSelect: (id: string) => void;
}

export const DietTypeCard = ({
    diet,
    isSelected,
    onSelect,
}: DietTypeCardProps) => {
    return (
        <div
            className={`relative bg-white p-6 rounded-lg shadow-sm cursor-pointer border-2 transition-colors ${
                isSelected
                    ? "border-primary"
                    : "border-transparent hover:border-gray-200"
            }`}
            onClick={() => onSelect(diet.id)}
        >
            {isSelected && (
                <div className="absolute top-4 right-4 w-6 h-6 bg-primary rounded-full flex items-center justify-center">
                    <Check className="text-white" size={16} />
                </div>
            )}
            <h3 className="text-xl font-semibold mb-2">{diet.name}</h3>
            <p className="text-gray-600 mb-4">{diet.description}</p>
            <p className="text-sm text-gray-500">{diet.objective}</p>
        </div>
    );
};
